/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarHeader/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CalendarHeader({
  children,
  viewPath = "/DesignSystem/Calendar/CalendarHeader",
  date = "Satu"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CalendarHeader.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<span
  data-testid="CalendarHeader.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{date}
</span>
</div>
{children}
</React.Fragment>)
}